<template>
  <div class="formData payment_record">
    <FormBox :title="$t('school.record_title')">
      <template slot="right">
        <el-button type="primary" plain @click="back">
          {{ $t("message.back") }}
        </el-button>
      </template>
      <el-table :data="showAll ? data : data.slice(0, 5)" v-loading="loading">
        <!-- 年度 -->
        <el-table-column :label="$t('school.taxYear')" prop="taxYear">
        </el-table-column>
        <!-- 個案查詢編號 -->
        <el-table-column :label="$t('school.spNo')" prop="spNo">
        </el-table-column>
        <!-- 服務日期 -->
        <el-table-column :label="$t('school.lastUpdDate')" prop="lastUpdDate">
        </el-table-column>
      </el-table>
    </FormBox>
    <div v-if="!showAll && data.length > 5" class="showMore">
      <span @click="showAllData">{{
        $t("message.DataRegistration.Taxi.showAll")
      }}</span>
    </div>
  </div>
</template>

<script>
import CoachRenewApplicationAPI from "../../../../api/CoachRenewApplicationAPI";
import HeadmasterRenewApplicationAPI from "../../../../api/HeadmasterRenewApplicationAPI";
import SchoolRenewApplicationAPI from "../../../../api/SchoolRenewApplicationAPI";
import FormBox from "../components/FormBox";
export default {
  components: { FormBox },
  data() {
    return {
      loading: false,
      showAll: false,
      data: [],
      serviceType: this.$route.params.serviceType,
      coachId: this.$route.params.coachId,
    };
  },
  methods: {
    showAllData() {
      this.showAll = true;
    },
    async get() {
      try {
        const serviceType = this.serviceType;
        const coachId = this.coachId;
        this.loading = true;
        let data = {};
        switch (serviceType) {
          case "SCHOOL_RENEW":
            data = await SchoolRenewApplicationAPI.history(
              serviceType,
              coachId
            );
            break;
          case "HEADMASTER_RENEW":
            data = await HeadmasterRenewApplicationAPI.history(
              serviceType,
              coachId
            );
            break;
          case "COACH_RENEW":
            data = await CoachRenewApplicationAPI.history(serviceType, coachId);
            break;
          default:
            break;
        }
        this.loading = await false;
        this.data = data.xmlRecords || [];
      } catch (error) {
        this.loading = false;
        this.$error(error);
      }
    },
    back() {
      const serviceType = this.serviceType;
      let path = "";
      switch (serviceType) {
        case "SCHOOL_RENEW":
          path = "/school-renew";
          break;
        case "HEADMASTER_RENEW":
          path = "/school-headmaster-renew";
          break;
        case "COACH_RENEW":
          path = "/school-coach-renew";
          break;
        default:
          break;
      }
      this.$router.push(path);
    },
  },
  created() {
    this.get();
  },
};
</script>

<style lang="scss" scoped>
.formData {
  overflow: hidden;
  max-width: 1048px;
  margin: auto;
  box-shadow: 0px 2px 7px 2px rgba(0, 0, 0, 0.16);
}
.payment_record {
  min-height: 800px;
  /deep/.el-table {
    margin: 30px 0;
    table {
      min-width: 530px;
      width: 100% !important;
    }
  }
  /deep/.el-table th {
    background: #5ba7ad;
    color: #fff;
    font-size: 16px;
    text-align: center;
  }

  /deep/.el-table--enable-row-transition .el-table__body td {
    text-align: center;
    font-size: 16px;
  }
}
.showMore {
  text-align: center;
}
.showMore span {
  display: inline-block;
  color: #5ba7ad;
  font-size: 18px;
  padding: 10px;
  border-top: 1px solid #5ba7ad;
  cursor: pointer;
}
</style>